module.exports = __webpack_public_path__ + "media/new/rejected-icon-6f4353e3.svg";